import { render, staticRenderFns } from "./ownDetails.vue?vue&type=template&id=77f27d12&scoped=true"
import script from "./ownDetails.vue?vue&type=script&lang=js"
export * from "./ownDetails.vue?vue&type=script&lang=js"
import style0 from "./ownDetails.vue?vue&type=style&index=0&id=77f27d12&prod&scoped=true&lang=css"
import style1 from "./ownDetails.vue?vue&type=style&index=1&id=77f27d12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f27d12",
  null
  
)

export default component.exports